import React from "react";
import UserFilesContractReview from "../components/File/userFilesContractReview";
import { NavLink, useSearchParams } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const FilesContractReview = () => {
	let [searchParams, setSearchParams] = useSearchParams();
	let project_id = searchParams.get("projectid")
	let project_type = "contractreview";
	return (
		<Container style={{  "max-width": "1300px"}}>
			<UserFilesContractReview project_id={project_id} />
			<Row>
				<Col className="text-align-end" style={{padding: '5px'}}>
					<NavLink to={"/querysearch?projectid=" + project_id + "&projecttype="+project_type}>
						<Button variant="primary">Query Search</Button>{' '}
					</NavLink>
				</Col>
			</Row>
			<Row>
				<Col className="text-align-end" style={{padding: '5px'}}>
					<NavLink to={"/entitysearch?projectid=" + project_id + "&projecttype="+project_type}>
						<Button variant="primary">Entity Search</Button>{' '}
					</NavLink>
				</Col>
			</Row>
			<Row>	
				<Col>
        			<Button variant="primary" onClick={() => window.print()}>Print</Button>
        		</Col>
        	</Row>
		</Container>
	);
};
export default FilesContractReview;